import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderEmpty = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 88 68",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.2811 67.8239C4.85592 67.8239 0.636353 63.608 0.636353 58.1875V10.0057C0.636353 4.73579 4.85592 0.369316 10.2811 0.369316H27.9129C30.4748 0.369316 32.8859 1.42329 34.6943 3.23011L38.7632 7.29545C40.5716 9.10227 42.9828 10.0057 45.5447 10.0057H63.3271C68.6016 10.0057 72.9719 14.3722 72.9719 19.642V24.4602H65.7383V19.642C65.7383 18.4375 64.5327 17.233 63.3271 17.233H45.5447C41.0237 17.233 36.8041 15.5767 33.6394 12.4148L29.5706 8.34943C29.1185 7.89772 28.5157 7.59659 27.9129 7.59659H10.2811C8.9248 7.59659 7.8699 8.80113 7.8699 10.0057V49.4545L18.1174 31.6875C19.0216 30.1818 20.5286 29.2784 22.337 29.2784H82.6166C84.2743 29.2784 85.932 30.1818 86.6855 31.6875C87.5897 33.1932 87.5897 35.1506 86.6855 36.6562L69.8072 65.5653C68.903 66.9205 67.396 67.8239 65.7383 67.8239H10.2811Z",
		fill: "#7E94ED"
	})
});
export default SvgFolderEmpty;
